import { useQuery } from '@tanstack/react-query'

import { MenuViewModel } from '@/types/api'

import fetchRequest from '@/app/_utils/fetch-request'
import { selectAPIService } from '@/app/_utils/select-api-service'

import { LayoutReactQueryKeys } from '../../types'

export function useLayoutMenu() {
    return useQuery<MenuViewModel>({
        queryKey: [LayoutReactQueryKeys.LayoutMenu],
        queryFn: () => {
            const serviceName = selectAPIService().ntl

            return fetchRequest({ endpoint: `/layout/menu`, method: 'GET', serviceName })
        },
        refetchOnMount: false,
        retryOnMount: false,
    })
}
